import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function Lock({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Add</title>
      <path
        d="M12.75 14C12.75 13.5858 12.4142 13.25 12 13.25C11.5858 13.25 11.25 13.5858 11.25 14H12.75ZM11.25 17C11.25 17.4142 11.5858 17.75 12 17.75C12.4142 17.75 12.75 17.4142 12.75 17H11.25ZM11 3.75H13V2.25H11V3.75ZM15.25 6V9H16.75V6H15.25ZM16 8.25H8V9.75H16V8.25ZM8.75 9V6H7.25V9H8.75ZM18.25 12V18H19.75V12H18.25ZM16 20.25H8V21.75H16V20.25ZM5.75 18V12H4.25V18H5.75ZM8 20.25C6.75736 20.25 5.75 19.2426 5.75 18H4.25C4.25 20.0711 5.92893 21.75 8 21.75V20.25ZM18.25 18C18.25 19.2426 17.2426 20.25 16 20.25V21.75C18.0711 21.75 19.75 20.0711 19.75 18H18.25ZM16 9.75C17.2426 9.75 18.25 10.7574 18.25 12H19.75C19.75 9.92893 18.0711 8.25 16 8.25V9.75ZM8 8.25C5.92893 8.25 4.25 9.92893 4.25 12H5.75C5.75 10.7574 6.75736 9.75 8 9.75V8.25ZM12.25 14C12.25 14.1381 12.1381 14.25 12 14.25V15.75C12.9665 15.75 13.75 14.9665 13.75 14H12.25ZM12 14.25C11.8619 14.25 11.75 14.1381 11.75 14H10.25C10.25 14.9665 11.0335 15.75 12 15.75V14.25ZM11.75 14C11.75 13.8619 11.8619 13.75 12 13.75V12.25C11.0335 12.25 10.25 13.0335 10.25 14H11.75ZM12 13.75C12.1381 13.75 12.25 13.8619 12.25 14H13.75C13.75 13.0335 12.9665 12.25 12 12.25V13.75ZM11.25 14V17H12.75V14H11.25ZM13 3.75C14.2426 3.75 15.25 4.75736 15.25 6H16.75C16.75 3.92893 15.0711 2.25 13 2.25V3.75ZM11 2.25C8.92893 2.25 7.25 3.92893 7.25 6H8.75C8.75 4.75736 9.75736 3.75 11 3.75V2.25Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
}
